import { render, staticRenderFns } from "./TickerTextCulture.vue?vue&type=template&id=20f885e3&scoped=true"
import script from "./TickerTextCulture.vue?vue&type=script&lang=js"
export * from "./TickerTextCulture.vue?vue&type=script&lang=js"
import style0 from "./TickerTextCulture.vue?vue&type=style&index=0&id=20f885e3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f885e3",
  null
  
)

export default component.exports